(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-home-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-home-products')) {
    customElements.define('gs-home-products', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const sw = e.target.closest('.gsh-sw');
          if (!sw) return;
          const card = sw.closest('[data-card]');
          card.querySelectorAll('.gsh-sw').forEach((b) => b.setAttribute('aria-pressed', String(b === sw)));
          card.querySelectorAll('[data-link]').forEach((a) => (a.href = sw.dataset.url));
          const img = card.querySelector('[data-img]');
          if (img && sw.dataset.src) {
            img.srcset = sw.dataset.srcset || '';
            img.src = sw.dataset.src;
            img.alt = sw.getAttribute('aria-label');
          }
          const col = card.querySelector('[data-color]');
          if (col) col.textContent = sw.dataset.color;
          const pr = card.querySelector('[data-price]');
          if (pr && sw.dataset.price) pr.textContent = sw.dataset.price;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-home-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gs-home-videos')) {
    customElements.define('gs-home-videos', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('.gsh-vid__play');
          if (!btn) return;
          const video = btn.parentElement.querySelector('video');
          if (!video) return;
          this.querySelectorAll('video').forEach((v) => {
            if (v !== video) {
              v.pause();
              v.controls = false;
              v.parentElement.classList.remove('is-playing');
            }
          });
          btn.parentElement.classList.add('is-playing');
          video.controls = true;
          video.play();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
